import { Button } from "@mui/material";
import React, { useRef, useState } from "react";



export default function DebitDataImport() {
  const [data, setData] = useState([]);
  const fileInputRef = useRef(null);
  const startsWithNumeric = (str) => {
    return /^\d/.test(str.trim()); // Check if the trimmed string starts with a digit
  };
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const lines = text.split("\n").filter((line) => line.trim() !== ""); // Split into lines
        const parsedData = lines.slice(1).map((line) => {
          const parts = line.split(/\s{2,}/); // Split on multiple spaces
          return {
            srNo: parts[0]?.trim(),
            trNo: parts[1]?.trim(),
            trDate: parts[2]?.trim(),
            trAmt: parts[3]?.trim(),
            trType: parts[4]?.trim(),
            station: parts[5]?.trim() || "",
            stationName: parts[6]?.trim() || "", // Handle cases where station name might be missing
          };
        });
        //const filteredData = parsedData.filter((row) => startsWithNumeric(row.srNo) && (row.trType.trim())!==""
        const filteredData = parsedData.filter((row) =>
            row?.srNo &&
            typeof row.trType === "string" &&
            startsWithNumeric(row.srNo) &&
            row.trType.trim() !== ""
        );
   
        setData(filteredData);
      };
      reader.readAsText(file);
    }
  };
  const handleButtonClick = () => {
    fileInputRef.current.click(); // Trigger click on hidden file input
  };
  return (
    <div>
      <h1>Debit Data (RIB CRIS)</h1>
      {/* <input
        type="file"
        accept=".txt"
        onChange={handleFileUpload}
        style={{ marginBottom: "20px" }}
      /> */}


      {/* Hidden file input */}
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileUpload}
        accept=".txt"
        style={{ display: "none" }}
      />
      {/* Button to trigger file input */}
      <Button onClick={handleButtonClick}>Select File</Button>

      {data && data.length > 0 && (
  <>

      <table border="1" cellPadding="10" style={{ width: "100%", textAlign: "left" }}>
        <thead>
          <tr>
            <th>SR NO</th>
            <th>TR NO</th>
            <th>TR DATE</th>
            <th>TR AMT</th>
            <th>TR TYPE</th>
            <th>STATION</th>
            <th>STATIONNAME</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td>{row.srNo}</td>
              <td>{row.trNo}</td>
              <td>{row.trDate}</td>
              <td>{row.trAmt}</td>
              <td>{row.trType}</td>
              <td>{row.station}</td>
              <td>{row.stationName}</td>
            </tr>
          ))}
        </tbody>
      </table>

      </>
)}
    </div>
  )
} 